import React from 'react';
import { Query } from 'react-apollo';
import Group from 'entities/Group';
import GET_INVITABLE_GROUPS from 'groups/queries/GetInvitableGroupsQuery.gql';
import { GetInvitableGroups } from 'groups/queries/__generated__/GetInvitableGroups';

type ChildrenProps = {
  groups?: Group[];
  loading?: boolean;
  error?: Error;
};

const InvitableGroupsContainer = ({
  children,
}: {
  children: (props: ChildrenProps) => React.ReactNode;
}) => (
  <Query<GetInvitableGroups> query={GET_INVITABLE_GROUPS}>
    {({ data, loading, error }) => {
      if (data && data.me) {
        const groups: Group[] = data.me.classes.map(clazz => new Group(clazz, { parse: true }));
        const invitableGroups = groups.filter(group => group.canAddPeople());
        return children({ groups: invitableGroups });
      }

      return children({ loading, error });
    }}
  </Query>
);

export default InvitableGroupsContainer;
